import { render, staticRenderFns } from "./PastEvents.vue?vue&type=template&id=799e1934&"
import script from "./PastEvents.vue?vue&type=script&lang=js&"
export * from "./PastEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('799e1934')) {
      api.createRecord('799e1934', component.options)
    } else {
      api.reload('799e1934', component.options)
    }
    module.hot.accept("./PastEvents.vue?vue&type=template&id=799e1934&", function () {
      api.rerender('799e1934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/PastEvents.vue"
export default component.exports